import createRoute                  from '@widesk-ui/tools/createRoute';
import StonecodeMailEditorMailModel from '@models/website/StonecodeMailEditorMailModel';

const route = createRoute.splitView(
	'/configuration/mails',
	'website',
	'MailSplitView',
	StonecodeMailEditorMailModel.localize('plural'),
);
export default route;
